/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Goto_CompanyInputs */

const en_admin_statistics_goto_company = /** @type {(inputs: Admin_Statistics_Goto_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to company`)
};

const de_admin_statistics_goto_company = /** @type {(inputs: Admin_Statistics_Goto_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Unternehmen`)
};

/**
* | output |
* | --- |
* | "Go to company" |
*
* @param {Admin_Statistics_Goto_CompanyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_goto_company = /** @type {((inputs?: Admin_Statistics_Goto_CompanyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Goto_CompanyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_goto_company(inputs)
	return en_admin_statistics_goto_company(inputs)
});